import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, useErrorHandler} from '../../../../shared';
import {Text} from '@gravity-ui/uikit';
import {useBlockById} from '../../../../entities';

interface DeleteBlockModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  blockId: string;
}

export const DeleteBlockModal = ({open, setOpen, blockId}: DeleteBlockModalProps) => {
  const {deleteBlockMutation} = useBlockById(blockId);

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Удаление блока',
    title: 'Ошибка при удалении блока',
  });

  useEffect(() => {
    if (deleteBlockMutation.error) {
      handleError(deleteBlockMutation.error as unknown as ApiError);
    }
  }, [deleteBlockMutation.error, handleError]);

  const handleSubmit = () => {
    deleteBlockMutation.mutate(blockId, {
      onSuccess: () => {
        setOpen(false);
      },
    });
  };

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        submitForm={handleSubmit}
        isLoading={deleteBlockMutation.isPending}
        size={'s'}
        buttonsSize={'l'}
        caption={'Удаление блока'}
        textButtonApply={'Удалить'}
        textButtonCancel={'Отменить'}
        viewActionButton="outlined-danger">
        <Text variant="body-2" color="secondary">
          Вы уверены, что хотите удалить этот блок? Обратите внимание, что это действие безвозвратное
        </Text>
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
